/**
 * « Ton deck » sous les offres d'achat (carte, pack) — UN seul bloc qui dit
 * tout : la règle (actif N mois après le dernier achat, toutes les cartes) et,
 * si l'élève a déjà un deck, SA date de fin. Remplace l'ancien doublon
 * « bandeau vert + encadré » des pages d'achat.
 */

import { CalendarClock } from 'lucide-react';
import { deckStatus, formatDeckDate } from '@jeraisonne/db/cards';
import { HelpTip } from '@/components/help-tip';
import { useMyDeck, validityLabel } from '@/lib/skillcards/purchase';

export function DeckNote({
  userId,
  validityMonths,
}: {
  userId: string | null;
  validityMonths: number;
}) {
  const deck = useMyDeck(userId);
  const info = deckStatus(deck.data);
  const duration = validityLabel(validityMonths);
  return (
    <div className="border-ink-200 ocean:bg-white/5 flex items-start gap-3 rounded-2xl border bg-white p-4">
      <CalendarClock className="text-primary-500 mt-0.5 h-5 w-5 shrink-0" aria-hidden />
      <p className="text-ink-700 text-sm">
        {info.active && deck.data ? (
          <>
            <strong className="text-ink-900">
              Ton deck
              <HelpTip topic="deck" label="deck" superscript /> est actif jusqu’au{' '}
              {formatDeckDate(deck.data)}.
            </strong>{' '}
            Un nouvel achat le prolonge de {duration} à partir d’aujourd’hui, pour toutes tes
            cartes.
          </>
        ) : (
          <>
            <strong className="text-ink-900">
              Ton deck
              <HelpTip topic="deck" label="deck" superscript /> est actif {duration} à partir de ton
              dernier achat.
            </strong>{' '}
            Toutes les cartes que tu as achetées, quel que soit leur niveau, restent actives jusqu’à
            cette date. Chaque nouvel achat relance {duration} pour tout ton deck.
          </>
        )}
      </p>
    </div>
  );
}
